"use strict";

require("core-js/modules/es6.object.assign");

var _taggedTemplateLiteral = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    padding: ", "px;\n    box-sizing: border-box;\n    width: ", "px;\n    height: ", "px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importStar(require("styled-components"));

var qrcode_react_1 = __importDefault(require("qrcode.react"));

var Wrapper = styled_components_1["default"].div(_templateObject(), function (_ref) {
  var theme = _ref.theme,
      size = _ref.size;
  return styled_components_1.css(_templateObject2(), theme.spacing.unit * 2, size + theme.spacing.unit * 2, size + theme.spacing.unit * 2);
});
/**
 * QRCode component
 *
 * Extended and customized from `qrcode.react`
 * https://github.com/zpao/qrcode.react
 *
 */

exports.QRCode = function (_a) {
  var value = _a.value,
      _a$size = _a.size,
      size = _a$size === void 0 ? 180 : _a$size,
      imageSettings = _a.imageSettings,
      rest = __rest(_a, ["value", "size", "imageSettings"]);

  return react_1["default"].createElement(Wrapper, {
    size: size
  }, react_1["default"].createElement(qrcode_react_1["default"], Object.assign({
    value: value,
    size: size,
    imageSettings: Object.assign(Object.assign({}, imageSettings), {
      excavate: true,
      height: size * 0.2,
      width: size * 0.2
    })
  }, rest)));
};

exports["default"] = exports.QRCode;